import React from 'react';
import PropTypes from 'prop-types';

export default function TimelineSlider({ 
    snapshots, 
    currentSnapshot, 
    onSnapshotSelect,
    selectedTimeRange,
    onTimeRangeChange,
    timeRanges 
}) {
    return (
        <div className="camera-sidebar">
            {/* Time Range Selector */}
            <div className="time-range-selector">
                <h4>Time Range</h4>
                <div className="time-range-buttons">
                    {timeRanges.map((range) => (
                        <button
                            key={range.value}
                            className={`time-range-btn ${selectedTimeRange === range.value ? 'active' : ''}`}
                            onClick={() => onTimeRangeChange(range.value)}
                        >
                            {range.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Snapshot Timeline */}
            <div className="snapshot-timeline">
                <h4>Recent Snapshots</h4>
                <div className="timeline-container">
                    {snapshots.map((snapshot, index) => (
                        <div 
                            key={snapshot.id} 
                            className={`timeline-item ${snapshot.id === currentSnapshot?.id ? 'current' : ''}`}
                            onClick={() => onSnapshotSelect(snapshot)}
                        >
                            <img 
                                src={snapshot.thumbnailUrl} 
                                alt={`Snapshot ${index + 1}`}
                                className="timeline-thumbnail"
                            />
                            <div className="timeline-info">
                                <span className="timeline-date">
                                    {(() => {
                                        try {
                                            const date = new Date(snapshot.timestamp);
                                            return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleDateString();
                                        } catch {
                                            return 'Invalid Date';
                                        }
                                    })()}
                                </span>
                                <span className="timeline-time">
                                    {(() => {
                                        try {
                                            const date = new Date(snapshot.timestamp);
                                            return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleTimeString();
                                        } catch {
                                            return 'Invalid Date';
                                        }
                                    })()}
                                </span>
                                <div className="timeline-sensors">
                                    <span className="sensor-mini">
                                        <i className="ri-temp-cold-line"></i>
                                        {snapshot.sensorData?.temperature}°
                                    </span>
                                    <span className="sensor-mini">
                                        <i className="ri-water-percent-line"></i>
                                        {snapshot.sensorData?.humidity}%
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

TimelineSlider.propTypes = {
    snapshots: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        timestamp: PropTypes.string.isRequired,
        thumbnailUrl: PropTypes.string.isRequired,
        sensorData: PropTypes.shape({
            temperature: PropTypes.number,
            humidity: PropTypes.number,
            light: PropTypes.number,
            water: PropTypes.number
        })
    })).isRequired,
    currentSnapshot: PropTypes.shape({
        id: PropTypes.string
    }),
    onSnapshotSelect: PropTypes.func.isRequired,
    selectedTimeRange: PropTypes.string.isRequired,
    onTimeRangeChange: PropTypes.func.isRequired,
    timeRanges: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    })).isRequired
}; 